/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";


// Fetches media preparation statistics for dashboard cards
const getMediaPreparationStats = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/media_batch_stats`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches media preparation batch list for inventory
const getMediaPreparationBatchList = async (page: number, size: number, sort: any, order: any, keyword: any, status?: string, lot?: string, mediaType?: string, fromDate?: string, toDate?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_preparation_batch?page=${page}&size=${size}&sort=${sort}&order=${order}${keyword ? `&keyword=${keyword}` : ''}${status ? `&status=${status}` : ''}${lot ? `&batch_name=${lot}` : ''}${mediaType ? `&media_name=${mediaType}` : ''}${fromDate ? `&from_date=${fromDate}` : ''}${toDate ? `&to_date=${toDate}` : ''}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

  // Fetches batch codes for the filter dropdown
const mediaPrepgetBatchCodes = async (keyword?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_preparation_batch?page=1&size=1000&sort=id&order=desc${
        keyword ? `&keyword=${keyword}` : ""
      }`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches media batch details (Batch Details screen)
const getMediaBatchDetails = async (batchId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/view_batch_details?page=1&size=50&sort=id&order=desc&id=${batchId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

export const mediaPreparationService = {
  getMediaPreparationBatchList,
  mediaPrepgetBatchCodes,
  getMediaPreparationStats,
  getMediaBatchDetails,
};